import { Link2 } from 'lucide-react';
import { useId, type ReactNode } from 'react';
import type { Network } from '../../api/types';
import { Button } from '../../components/ui';
import { strings } from '../../strings';
import { useAttachReason } from './hooks';

const p = strings.networks.page;

/** Attach deployments…, `aria-disabled` with its reason when the user can't attach. */
export function AttachButton({
  network,
  onAttach,
  icon,
  variant,
}: {
  network: Pick<Network, 'name' | 'settings'>;
  onAttach: () => void;
  icon?: ReactNode;
  variant?: 'default' | 'primary';
}) {
  const reason = useAttachReason(network);
  const reasonId = useId();
  return (
    <>
      <Button
        variant={variant}
        icon={icon ?? <Link2 aria-hidden className="size-4" />}
        aria-disabled={reason ? true : undefined}
        aria-describedby={reason ? reasonId : undefined}
        title={reason ?? undefined}
        onClick={(event) => {
          if (reason) {
            event.preventDefault();
            return;
          }
          onAttach();
        }}
      >
        {p.attachDeployments}
      </Button>
      {reason && (
        <span id={reasonId} className="sr-only">
          {reason}
        </span>
      )}
    </>
  );
}
